var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_46966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66757 5.16715H4.49138C4.85135 6.49158 6.21681 7.27344 7.54124 6.91348C8.39187 6.68228 9.05637 6.01779 9.28756 5.16715H17.3328C17.7009 5.16715 17.9994 4.86871 17.9994 4.50056C17.9994 4.13241 17.7009 3.83397 17.3328 3.83397H9.28756C8.9276 2.50951 7.56214 1.72765 6.23771 2.08762C5.38708 2.31881 4.72258 2.98331 4.49138 3.83394H2.66757C2.29942 3.83394 2.00098 4.13238 2.00098 4.50053C2.00098 4.86868 2.29942 5.16715 2.66757 5.16715Z",
    fill: "#C2C6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3328 9.33362H15.5089C15.1497 8.00938 13.785 7.22708 12.4607 7.5863C11.6094 7.81724 10.9444 8.48227 10.7134 9.33362H2.66757C2.29942 9.33362 2.00098 9.63206 2.00098 10.0002C2.00098 10.3684 2.29942 10.6668 2.66757 10.6668H10.7134C11.0727 11.991 12.4374 12.7733 13.7616 12.4141C14.6129 12.1832 15.278 11.5182 15.5089 10.6668H17.3328C17.7009 10.6668 17.9994 10.3684 17.9994 10.0002C17.9994 9.63206 17.7009 9.33362 17.3328 9.33362Z",
    fill: "#C2C6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3328 14.833H9.28756C8.9276 13.5085 7.56214 12.7267 6.23771 13.0866C5.38708 13.3178 4.72258 13.9823 4.49138 14.833H2.66757C2.29942 14.833 2.00098 15.1314 2.00098 15.4996C2.00098 15.8677 2.29942 16.1661 2.66757 16.1661H4.49138C4.85135 17.4906 6.21681 18.2724 7.54124 17.9125C8.39187 17.6813 9.05637 17.0168 9.28756 16.1661H17.3328C17.7009 16.1661 17.9994 15.8677 17.9994 15.4996C17.9994 15.1314 17.7009 14.833 17.3328 14.833Z",
    fill: "#C2C6CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_46966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.edffdbe30bcb82178617c5fd716e5f84.svg";
export { ForwardRef as ReactComponent };